import ReCAPTCHA from 'react-google-recaptcha';
import { message } from 'antd';
import css from './ModalForm.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { rpcMap } from '@/constants/lang';
import { submitForm } from '@/service/delta-pro-ultra';

export default function ModalForm({ callback }: any) {
    const { useState, useRef } = useGlobal();
    const [formData, setFormData] = useState({ agreed: true, purchased: false, recaptchaResponse: '', address4: '', departmentName: '', content: '' });
    const [showTip, setShowTip] = useState({});
    const recaptchaRef = useRef();
    const hl = rpcMap['jp'];
    const SECRET_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_REGISTER_SECRET_KEY;

    const handleInput = (e: any, key: string) => {
        setFormData({ ...formData, [key]: e.target.value });
        showTip[key] && setShowTip({ ...showTip, [key]: false });
    };

    const hanldeCheck = (e: any, key: string) => {
        setFormData({ ...formData, [key]: e.target.checked });
    };

    const handleSubmit = async () => {
        const tipObj = {};
        const requireArr = ['katakana', 'hiragana', 'zipCode', 'address1', 'address2', 'address3', 'email', 'phone', 'agreed', 'recaptchaResponse'];
        requireArr.map((item: string) => (tipObj[item] = Boolean(!formData[item])));
        const zipRegex = /^[0-9-]+$/;
        const zipFlag = zipRegex.test(formData.zipCode);
        if (!zipFlag) {
            tipObj.zipCode = true;
        }
        const emailRegex = /^[\w.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const emailFlag = emailRegex.test(formData.email);
        if (!emailFlag) {
            tipObj.email = true;
        }
        const phoneRegex = /^[0-9-]+$/;
        const phoneFlag = phoneRegex.test(formData.phone);
        if (!phoneFlag) {
            tipObj.phone = true;
        }
        setShowTip(tipObj);
        if (Object.values(tipObj).every((list: boolean) => !list)) {
            try {
                const res = await submitForm(formData, 'jp');
                if (res?.code === '0') {
                    message.success('送信成功しました！');
                    callback();
                } else {
                    message.error('送信失敗しました！');
                }
            } catch (e) {
                console.error(e);
                message.error('送信失敗しました！');
            }
        }
    };

    const onReCAPTCHAChange = async (recaptchaResponse: string) => {
        if (!recaptchaResponse) {
            return;
        }
        setFormData({ ...formData, recaptchaResponse });
    };

    const tipIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <g clipPath="url(#clip0_7503_9424)">
                <path
                    d="M6.14966 3L6.46258 7.78185H7.53742L7.85034 3H6.14966ZM6.9932 8.94459C6.72109 8.94459 6.4898 9.0285 6.29932 9.22431C6.09524 9.40613 6 9.64389 6 9.9376C6 10.2173 6.09524 10.4551 6.29932 10.6509C6.4898 10.8467 6.72109 10.9446 6.9932 10.9446C7.26531 10.9446 7.5102 10.8467 7.71429 10.6649C7.90476 10.4691 8 10.2313 8 9.9376C8 9.64389 7.90476 9.40613 7.71429 9.22431C7.52381 9.0285 7.27891 8.94459 6.9932 8.94459Z"
                    fill="#F8200C"
                />
                <path
                    d="M7 13.5C10.5899 13.5 13.5 10.5899 13.5 7C13.5 3.41015 10.5899 0.5 7 0.5C3.41015 0.5 0.5 3.41015 0.5 7C0.5 10.5899 3.41015 13.5 7 13.5Z"
                    stroke="#F8200C"
                />
            </g>
            <defs>
                <clipPath id="clip0_7503_9424">
                    <rect width="14" height="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );

    return (
        <div className={`modal-form ${css['modal-form']}`}>
            <div className="modal-form-content">
                <div className="form-header">
                    <p className="header-title">導入のご相談やお見積りのご依頼はこちら</p>
                    <svg className="header-close" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" onClick={callback}>
                        <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className="form-main">
                    <p className="main-title">お問い合わせフォーム</p>
                    <div className="form-items">
                        <div className="form-item">
                            <p className="item-label required">氏名（漢字）</p>
                            <input
                                type="text"
                                className={`input ${showTip?.hiragana ? 'error' : ''}`}
                                value={formData?.hiragana}
                                onChange={(e: any) => handleInput(e, 'hiragana')}
                            />
                            {showTip?.hiragana && (
                                <div className="tip">
                                    <span className="tip-icon">{tipIcon}</span>
                                    <span className="tip-text">氏名（漢字）をご入力ください</span>
                                </div>
                            )}
                        </div>
                        <div className="form-item">
                            <p className="item-label required">氏名（フリガナ）</p>
                            <input
                                type="text"
                                className={`input ${showTip?.katakana ? 'error' : ''}`}
                                value={formData?.katakana}
                                onChange={(e: any) => handleInput(e, 'katakana')}
                            />
                            {showTip?.katakana && (
                                <div className="tip">
                                    <span className="tip-icon">{tipIcon}</span>
                                    <span className="tip-text">氏名（フリガナ）をご入力ください</span>
                                </div>
                            )}
                        </div>
                        <div className="form-item">
                            <p className="item-label">会社名</p>
                            <input
                                type="text"
                                className={`input ${showTip?.companyName ? 'error' : ''}`}
                                value={formData?.companyName}
                                onChange={(e: any) => handleInput(e, 'companyName')}
                            />
                        </div>
                        <div className="form-item">
                            <p className="item-label">会社HP</p>
                            <input
                                type="text"
                                className={`input ${showTip?.companyWebsite ? 'error' : ''}`}
                                value={formData?.companyWebsite}
                                onChange={(e: any) => handleInput(e, 'companyWebsite')}
                            />
                        </div>
                        <div className="form-item">
                            <p className="item-label">部署名</p>
                            <input
                                type="text"
                                className={`input ${showTip?.departmentName ? 'error' : ''}`}
                                value={formData?.departmentName}
                                onChange={(e: any) => handleInput(e, 'departmentName')}
                            />
                        </div>
                        <div className="form-item">
                            <p className="item-label required">郵便番号</p>
                            <input
                                type="text"
                                className={`input ${showTip?.zipCode ? 'error' : ''}`}
                                value={formData?.zipCode}
                                onChange={(e: any) => handleInput(e, 'zipCode')}
                            />
                            {showTip?.zipCode && (
                                <div className="tip">
                                    <span className="tip-icon">{tipIcon}</span>
                                    <span className="tip-text">有効な郵便番号をご入力ください</span>
                                </div>
                            )}
                        </div>
                        <div className="form-item">
                            <p className="item-label required">都道府県</p>
                            <input
                                type="text"
                                className={`input ${showTip?.address1 ? 'error' : ''}`}
                                value={formData?.address1}
                                onChange={(e: any) => handleInput(e, 'address1')}
                            />
                            {showTip?.address1 && (
                                <div className="tip">
                                    <span className="tip-icon">{tipIcon}</span>
                                    <span className="tip-text">都道府県をご入力ください</span>
                                </div>
                            )}
                        </div>
                        <div className="form-item">
                            <p className="item-label required">市区町村</p>
                            <input
                                type="text"
                                className={`input ${showTip?.address2 ? 'error' : ''}`}
                                value={formData?.address2}
                                onChange={(e: any) => handleInput(e, 'address2')}
                            />
                            {showTip?.address2 && (
                                <div className="tip">
                                    <span className="tip-icon">{tipIcon}</span>
                                    <span className="tip-text">市区町村をご入力ください</span>
                                </div>
                            )}
                        </div>
                        <div className="form-item">
                            <p className="item-label required">番地</p>
                            <input
                                type="text"
                                className={`input ${showTip?.address3 ? 'error' : ''}`}
                                value={formData?.address3}
                                onChange={(e: any) => handleInput(e, 'address3')}
                            />
                            {showTip?.address3 && (
                                <div className="tip">
                                    <span className="tip-icon">{tipIcon}</span>
                                    <span className="tip-text">番地をご入力ください</span>
                                </div>
                            )}
                        </div>
                        <div className="form-item">
                            <p className="item-label">建物名・部屋番号</p>
                            <input
                                type="text"
                                className={`input ${showTip?.address4 ? 'error' : ''}`}
                                value={formData?.address4}
                                onChange={(e: any) => handleInput(e, 'address4')}
                            />
                            {showTip?.address4 && (
                                <div className="tip">
                                    <span className="tip-icon">{tipIcon}</span>
                                    <span className="tip-text">建物名・部屋番号をご入力ください</span>
                                </div>
                            )}
                        </div>
                        <div className="form-item">
                            <p className="item-label required">メールアドレス</p>
                            <input
                                type="text"
                                className={`input ${showTip?.email ? 'error' : ''}`}
                                value={formData?.email}
                                onChange={(e: any) => handleInput(e, 'email')}
                            />
                            {showTip?.email && (
                                <div className="tip">
                                    <span className="tip-icon">{tipIcon}</span>
                                    <span className="tip-text">有効なメールアドレスをご入力ください</span>
                                </div>
                            )}
                        </div>
                        <div className="form-item">
                            <p className="item-label required">電話番号</p>
                            <input
                                type="text"
                                className={`input ${showTip?.phone ? 'error' : ''}`}
                                value={formData?.phone}
                                onChange={(e: any) => handleInput(e, 'phone')}
                            />
                            {showTip?.phone && (
                                <div className="tip">
                                    <span className="tip-icon">{tipIcon}</span>
                                    <span className="tip-text">有効な電話番号をご入力ください</span>
                                </div>
                            )}
                        </div>
                        <div className="form-item textarea">
                            <p className="item-label">お問い合わせ内容</p>
                            <textarea
                                rows="4"
                                maxLength="1000"
                                className={`input ${showTip?.content ? 'error' : ''}`}
                                value={formData?.content}
                                onChange={(e: any) => handleInput(e, 'content')}
                            />
                        </div>
                        <div className="form-dpu-check">
                            <input
                                className="check-dpu"
                                id="check-dpu"
                                type="checkbox"
                                checked={formData?.purchased}
                                onChange={(e: any) => hanldeCheck(e, 'purchased')}
                            />
                            <label htmlFor="check-dpu" className="dpu-text">
                                すでにDELTA Pro Ultraをお持ちですか？
                            </label>
                        </div>
                        <div className="form-terms-box">
                            <p className="terms-title">個人情報のお取扱い</p>
                            <p className="terms-text">
                                お問い合わせの際にご記入いただきましたお客様の個人情報（ご担当者様氏名・E-mailアドレス・電話番号など）につきまして、下記のとおり責任を持って管理いたします。
                                <br />
                                当社は、お客様から送信されたお問い合わせへの対応およびその確認などに利用させていただき、この目的のためにお問い合わせの記録を残すことがあります。
                                <br />
                                お問い合わせに対し適切な回答をするために、当社関係会社および委託業者に個人情報を含むお問い合わせ内容を転送することがございます。お客様の個人情報につきまして上記の利用目的以外の目的で、第三者へ開示することはございません。
                                その他の個人情報のお取扱い詳細については、
                                <a href="https://jp.ecoflow.com/pages/privacy-policy" target="_blank" rel="noreferrer">
                                    こちら
                                </a>
                                をご覧ください。
                            </p>
                            <div className="form-terms-check">
                                <input
                                    className="check-terms"
                                    id="terms"
                                    type="checkbox"
                                    checked={formData?.agreed}
                                    onChange={(e: any) => hanldeCheck(e, 'agreed')}
                                />
                                <label htmlFor="terms" className="terms-agree">
                                    利⽤規約、個人情報の取り扱いに同意する
                                </label>
                            </div>
                        </div>
                        <div className="g-recaptcha">
                            {/* @ts-ignore */}
                            <ReCAPTCHA ref={recaptchaRef} size={'normal'} sitekey={SECRET_KEY} hl={hl} onChange={onReCAPTCHAChange} />
                        </div>
                    </div>
                    <button className="submit" disabled={!formData?.agreed || !formData?.recaptchaResponse} onClick={handleSubmit}>
                        送 信
                    </button>
                </div>
            </div>
        </div>
    );
}
